import { useCallback } from 'react';

import { Grid, Switch, Typography } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';

import usePanelToggleState from '../../../../hooks/usePanelToggleState';

import type { ChangeEvent } from 'react';
import type { ValueOf } from '@kc-console/core';

const PANEL_TOGGLE = {
  LIST: 'LIST',
  DETAIL: 'DETAIL',
} as const;

interface PanelToggleItemProps {
  type: ValueOf<typeof PANEL_TOGGLE>;
}

export const PanelListToggleItem = () => {
  return <PanelToggleItem type={PANEL_TOGGLE.LIST} />;
};

export const PanelDetailToggleItem = () => {
  return <PanelToggleItem type={PANEL_TOGGLE.DETAIL} />;
};

const PanelToggleItem = ({ type }: PanelToggleItemProps) => {
  const { t } = useTranslation();
  const {
    enableDetailPanel,
    enableListPanel,
    updateListPanelEnableState,
    updateDetailPanelEnableState,
  } = usePanelToggleState();

  const isListType = type === 'LIST';
  const title = isListType
    ? t('layout:setting.panel.resource_list')
    : t('layout:setting.panel.detail_view');
  const checked = isListType ? enableListPanel : enableDetailPanel;

  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.checked;
      return isListType ? updateListPanelEnableState(value) : updateDetailPanelEnableState(value);
    },
    [isListType, updateListPanelEnableState, updateDetailPanelEnableState],
  );

  return (
    <Grid container flexDirection="row" justifyContent="space-between" alignItems="center">
      <Typography variant={'label/regular/md'}>{title}</Typography>
      <Switch checked={checked} onChange={onChange} />
    </Grid>
  );
};
